;
(function ($) {
	window.esriHomePageSlider = new (function () {
		var self = {},
			defaultSettings = {
				autoPlay: true,
				transitionType: 'slide',
				domId: '#homePageSlider',
				sliderItems: [],
				timeBetweenSlidesInMilliseconds: 4000,
				slideSpeed: 90,
				contentItemSpeed: 50,
				bounceSpeed: 20,
				bounceDistance: 35,
				slideWidth: null,
				slideHeight: 420,
				mobileSlideHeight: 350,
				masterContainerTemplate: null,
				slideTemplate: null,
				rotatorControlTemplate: null,
				mobileWidth: 1000,
				loops: 1000,
				staticText : null
			};

		var currentSlideNum = 1,
			currentIteration = 0,
			enabled = true,
			timer,
			contentElementsToNavigate = 'h1, h2, h3, h4, div, p';

		//*****************************************************
		// Query String overides
		//*****************************************************
		self.applyQueryStringOverides = function () {
			self.settings.timeBetweenSlidesInMilliseconds = $GET('slider_Pause') ? $GET('slider_Pause') : self.settings.timeBetweenSlidesInMilliseconds;
			self.settings.slideSpeed = $GET('slider_slideSpeed') ? $GET('slider_slideSpeed') : self.settings.slideSpeed;
			self.settings.contentItemSpeed = $GET('slider_contentItemSpeed') ? $GET('slider_contentItemSpeed') : self.settings.slideSpeed;
			self.settings.bounceSpeed = $GET('slider_bounceSpeed') ? $GET('slider_bounceSpeed') : self.settings.bounceSpeed;
			self.settings.bounceDistance = $GET('slider_bounceDistance') ? $GET('slider_bounceDistance') : self.settings.bounceDistance;
			self.settings.loops = $GET('slider_loops') ? $GET('slider_loops') : self.settings.loops;
			self.settings.transitionType = $GET('transition_type') ? $GET('transition_type') : self.settings.transitionType;
		};


		//*****************************************************
		// Templates Section
		//*****************************************************

		self.templates = {
			masterContainer: '<div class="rotator-wrapper" style="width:${SlideWidth}px ; height : ${SlideHeight}"><div id="rotator"><div id="rotator-items">${Slides}</div></div><div id="rotator-controls">${Controls}</div><div id="static-text">${StaticText}</div>',
			slide: '<a href="${SlideHref}"><div class="slide" id="${SlideID}" style="background-image: url(\'${SlideImg}\'); width : ${SlideWidth}px; height : ${SlideHeight}"><div class="content">${SlideContent}</div></div></a>',
			rotatorControl: '<a class="rotator-pager-item" data-slide-index="${SlideIndex}">${SlideIndex}</a>'
		};

		self.setTemplates = function () {
			if (self.settings.masterContainerTemplate !== null) {
				self.templates.masterContainer = self.settings.masterContainerTemplate;
			}

			if (self.settings.slideTemplate !== null) {
				self.templates.slide = self.settings.slideTemplate;
			}

			if (self.settings.rotatorControlTemplate !== null) {
				self.templates.rotatorControl = self.settings.rotatorControlTemplate;
			}

			if (self.settings.slideWidth === null) {
				self.settings.slideWidth = $(window).width();
			}
		};



		//*****************************************************
		// Html Generation Section
		//*****************************************************
		self.sizeMode = 'normal';
		self.generateHtml = function () {
			return fillTemplate(self.templates.masterContainer, {
				Slides: self.generateSliderHtmlElements(),
				Controls: self.generateSliderControls(),
				SlideWidth: self.settings.slideWidth,
				SlideHeight: self.settings.slideHeight === null ? '' : self.settings.slideHeight + "px",
				StaticText : self.settings.staticText === null ? '' : self.settings.staticText
			});
		};

		self.generateSliderHtmlElements = function () {
			var index = 1,
				slidesHtml = '';

			self.sizeMode = $(window).width() <= self.settings.mobileWidth ? 'mobile' : 'normal';

			_.each(self.settings.sliderItems, function (sItem) {

				var slideBackground = sItem.src;
				if (self.sizeMode == 'mobile' && sItem.mobile_src) {
					slideBackground = sItem.mobile_src;
				}

				slidesHtml += fillTemplate(self.templates.slide, {
					SlideImg: slideBackground,
					SlideWidth: self.settings.slideWidth,
					SlideHeight: self.settings.slideHeight === null ? '' : self.settings.slideHeight + "px",
					SlideID: 'featured' + index,
					SlideHref: sItem.href,
					SlideContent: sItem.caption
				});

				index++;
			});

			return slidesHtml;
		};

		//*****************************************************
		// Slide Size / Mobile
		//*****************************************************

		self.updateBackgroundImages = function () {
			var sizeMode = $(window).width() <= self.settings.mobileWidth ? 'mobile' : 'normal';
			if (sizeMode != self.sizeMode && self.settings.sliderItems.length > 0) {
				self.sizeMode = sizeMode;

				for (var i = 0; i < self.settings.sliderItems.length; i++) {
					var sItem = self.settings.sliderItems[i];
					if (sItem.mobile_src != null) {
						var slide = $("#featured" + (i + 1));
						var backgroundImg = (self.sizeMode == 'normal') ? sItem.src : sItem.mobile_src;

						$(slide).css('background-image', 'url("' + backgroundImg + '")');
					}
				}
			}
		};

		self.setSlideDimensions = function () {
			self.settings.slideWidth = $(window).width();
			self.domNode.width(self.settings.slideWidth);
			self.domNode.find('.rotator-wrapper').width(self.settings.slideWidth);
			self.domNode.find('.slide').width(self.settings.slideWidth);

			if (self.settings.mobileSlideHeight) {
				var height = (self.sizeMode == 'normal') ? self.settings.slideHeight : self.settings.mobileSlideHeight;
				$('.rotator-wrapper, .rotator-wrapper').css('height', height + 'px');
			}
		};

		self.resizeSlider = function () {
			self.updateBackgroundImages();
			self.setSlideDimensions();

			if (self.settings.transitionType == 'slide') {
				var leftX = -(self.settings.slideWidth * (currentSlideNum - 1));
				self.domNode.find("#rotator-items")
					.removeClass('animate-slide')
					.css('left', leftX);
				self.domNode.find('.rotator-wrapper .active .content *').css('left', '0');
			}
		};



		//*****************************************************
		// Slider Controlls
		//*****************************************************

		self.generateSliderControls = function () {
			var controlsHtml = '';
			for (var i = 1; i < self.settings.sliderItems.length + 1; i++) {
				controlsHtml += fillTemplate(self.templates.rotatorControl, {
					SlideIndex: i
				});
			}
			return controlsHtml;
		};

		//*****************************************************
		// Pager and Auto Rotation
		//*****************************************************
		self.setActivePager = function (slideNum) {
			var pagerItems = self.domNode.find(".rotator-pager-item");
			pagerItems.removeClass('active');
			pagerItems.parent().find("[data-slide-index='" + slideNum + "']").addClass('active');
		};

		self.registerPagerClick = function () {
			self.domNode.find(".rotator-pager-item").click(function (e) {
				e.preventDefault();
				clearTimeout(timer);
				enabled = false;
				var targetId = $(this).attr('data-slide-index');
				self.goToSlide(targetId);
			});
		};

		self.scheduleNextSlideChange = function () {
			if (enabled && self.settings.loops != 0 && currentIteration < self.settings.loops) {
				//Set Next Change
				timer = setTimeout(function () {
					self.goToSlide(currentSlideNum + 1);
				}, self.settings.timeBetweenSlidesInMilliseconds);
			}
		};

		//*****************************************************
		// Top Level GoTo Slide
		//*****************************************************
		self.goToSlide = function (n) {
			if (currentSlideNum != parseInt(n)) {

				switch (self.settings.transitionType) {
					case "slide":
						self.slideToNextSlide(n);
						break;
					case "fade":
						self.fadeToNextSlide(n);
						break;
				}

			} else {
				self.setActivePager(currentSlideNum);
				self.scheduleNextSlideChange();
			}
		};

		//*****************************************************
		//	Slide Mode Implementation
		//*****************************************************
		self.animateObject = function (obj, endPoint, speed) {
			var deferred = $q.defer();

			var easingTimeInSeconds = speed / 100,
				easingTimeInMiliseconds = easingTimeInSeconds * 1000;

			$(obj).animate({
				'left': endPoint + 'px'
			}, easingTimeInMiliseconds, function () {
				deferred.resolve(obj);
			});

			return deferred.promise;
		};

		//Animates The Bounce In/Out Of a single content Item On Slide
		self.animateContentItem = function (contentItem, bounce, end, direction) {
			var deferred = $q.defer();
			if (direction == 'out') {
				//bounce first
				self.animateObject(contentItem, bounce, self.settings.bounceSpeed).then(function () {
					self.animateObject(contentItem, end, self.settings.contentItemSpeed).then(function () {
						deferred.resolve();
					});
				});
			} else {
				//bounce second
				self.animateObject(contentItem, end - bounce, self.settings.contentItemSpeed).then(function () {
					self.animateObject(contentItem, 0, self.settings.bounceSpeed).then(function () {
						deferred.resolve();
					});
				});
			}
			return deferred.promise;
		};

		self.hideNonVisibleItems = function () {
			if (self.settings.transitionType == "slide") {
				self.domNode.find('.slide .content').find(contentElementsToNavigate).hide();
				var curentContent = self.domNode.find('.slide .content')[currentSlideNum - 1];
				$(curentContent).find(contentElementsToNavigate).show();
			}
		};

		//-- Navigate To Specified Slide
		self.slideToNextSlide = function (n) {
			self.hideNonVisibleItems();

			//Determine previous and next slide numbers
			var previousSlideNum = currentSlideNum;

			currentSlideNum = parseInt(n);
			if (currentSlideNum > self.settings.sliderItems.length) {
				currentSlideNum = 1;
				currentIteration++;
			}

			//Determine direction and bounce value
			var direction = previousSlideNum > currentSlideNum ? 'right' : 'left',
				bounce = direction == 'right' ? -self.settings.bounceDistance : self.settings.bounceDistance;


			//TODO:break this apart
			var processPreviousContentItemsOut = function (done) {
				var pSlide = self.domNode.find('#featured' + previousSlideNum),
					pSlideContent = pSlide.find('.content'),
					pSlideContentItems = pSlideContent.find(contentElementsToNavigate),
					slideTo = direction == 'right' ?
						self.settings.slideWidth - pSlide.find('.content').offset().left :
						-(pSlideContent.width() + pSlide.find('.content').offset().left),
					i = 0;

				//Hide all items except the ones we will be working with
				self.domNode.find('.slide').removeClass('active');
				pSlide.addClass('active');



				var processItem = function (item, done) {
					self.animateContentItem(item, bounce, slideTo, 'out').then(function () {
						i++;
						if (i < pSlideContentItems.length) {
							processItem(pSlideContentItems[i], function () {
								done();
							});
						} else {
							done();
						}
					});
				};

				processItem(pSlideContentItems[i], function () {
					done();
				});

			};

			var processSliderBackground = function (done) {
				var leftX = -(self.settings.slideWidth * (currentSlideNum - 1)),
					slideContainer = self.domNode.find("#rotator-items"),
					speedMutator = currentSlideNum > previousSlideNum
						? currentSlideNum - previousSlideNum
						: previousSlideNum - currentSlideNum;

				self.animateObject(slideContainer, leftX, self.settings.slideSpeed - (speedMutator * 10)).then(function () {
					done();
				});
			};

			//TODO:Break this apart
			var processIncomingContentItemsIn = function (done) {
				var iSlide = self.domNode.find('#featured' + currentSlideNum),
					iSlideContent = iSlide.find('.content'),
					iSlideContentItems = iSlideContent.find(contentElementsToNavigate),
					i = 0;

				//Get the left offset of the content block
				iSlideContent.show();
				var contentOffset = iSlideContent.offset().left;

				var incomingStagePosition = direction == 'right' ?
					-(self.settings.slideWidth + contentOffset) :
					(iSlideContent.width() + contentOffset);

				iSlideContentItems.css('left', incomingStagePosition);
				iSlide.addClass('active');
				iSlideContentItems.show();

				var processItem = function (item, done) {
					self.animateContentItem(item, bounce, 0, 'in').then(function () {
						i++;
						if (i < iSlideContentItems.length) {
							processItem(iSlideContentItems[i], function () {
								done();
							});
						} else {
							done();
						}
					});
				};

				processItem(iSlideContentItems[i], function () {
					done();
				});
			};

			//Run Animation Sequence
			processPreviousContentItemsOut(function () {
				processSliderBackground(function () {
					self.setActivePager(currentSlideNum);

					processIncomingContentItemsIn(function () {
						self.domNode.find('.rotator-wrapper .content *').css('left', '');
						self.scheduleNextSlideChange();
					});
				});
			});
		};


		//*****************************************************
		//	Fade Mode Implementation
		//*****************************************************
		self.fadeToNextSlide = function (n) {
			$('.rotator-wrapper .slide .content>*').show();

			var currentSlide = self.domNode.find('#featured' + currentSlideNum);
			var nextSlide = self.domNode.find('#featured' + n);
			if(nextSlide.length == 0)
			{
				nextSlide = self.domNode.find('#featured' + 1);
				n = 1;
				currentIteration++;
			}

			
					
			$(currentSlide).fadeOut(self.settings.slideSpeed * 10, function() {
				$(currentSlide).removeClass('active');
			});
			$(nextSlide).fadeIn(self.settings.slideSpeed * 10, function() {
				$(nextSlide).addClass('active');
			});

			self.setActivePager(n);

			currentSlideNum = parseInt(n);
			if (currentSlideNum > self.settings.sliderItems.length) {
				currentSlideNum = 1;
				currentIteration++;
			}

			self.scheduleNextSlideChange();
		};

		//*****************************************************
		// Init Section
		//*****************************************************
		self.init = function (options) {
			$(function() {
				self.settings = _.create(defaultSettings, options);

				self.domNode = $(self.settings.domId);

				self.applyQueryStringOverides();
				self.setTemplates();

				var useExistingHtml = self.settings.sliderItems.length === 0;
				if (useExistingHtml) {
					self.settings.sliderItems = self.domNode.find('.slide');
					self.domNode.append('<div id="rotator-controls">' + self.generateSliderControls() + '</div>');
				} else {
					var html = self.generateHtml();
					self.domNode.html(html);
				}

				var rWrapper = self.domNode.find('.rotator-wrapper');
				if (rWrapper.length == 0) {
					rWrapper = self.domNode;
				}
				rWrapper.addClass(self.settings.transitionType + '-mode');

				self.hideNonVisibleItems();
				self.updateBackgroundImages();
				self.setSlideDimensions();

				self.domNode.find('.slide').first().addClass('active');

				$(window).resize(function () {
					self.resizeSlider();
				});
				self.registerPagerClick();
				self.goToSlide(1);

				//*****************************************************
				// Swipe Actions
				//*****************************************************
				var hammerHandler = new Hammer(self.domNode[0]);
				hammerHandler.on('swipe', function (event) {
					var slideToLoad = 0;
					switch (event.direction) {
						//Left
						case 2:
							slideToLoad = currentSlideNum + 1;
							if (slideToLoad > self.settings.sliderItems.length) {
								slideToLoad = 1;
							}
							break;
						//Right
						case 4:
							slideToLoad = currentSlideNum - 1;
							if (slideToLoad == 0) {
								slideToLoad = self.settings.sliderItems.length;
							}
							break;
					}

					clearTimeout(timer);
					enabled = false;
					self.goToSlide(slideToLoad);

					console.log('swipe', event);
				});
			});
		};

		return self;
	})();


	//*****************************************************
	// Support for legacy JQuery Plugin
	//*****************************************************
	$.fn.esriHomePageSlider = function (options) {
		return this.each(function () {
			var domId = $(this).attr('id');

			var settings = _.extend(options, {
				domId: "#" + domId
			});

			esriHomePageSlider.init(settings);
		});
	};
}(jQuery));
